export const fetchCityList = async (request, setter) => {
    try {
        const response = await request(
            "GET",
            `/v1/survey/locations/city-profile`,
            {},
            "survey_service"
        );
        setter(response);
    } catch (error) {
        console.log(error);
    }
};


export const fetchSectionWiseData = async (request, payload) => {
    try {
        const response = await request(
            "GET",
            `/v1/city-profile/${payload.section}?location=${payload.location}&year=${payload.year}`,
            {},
            "survey_service"
        );
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const postSectionWiseData = async (request, payload) => {
    try {
        const response = await request(
            "POST",
            `/v1/city-profile/section`,
            {
                data: payload.postPayload,
            },
            "survey_service"
        );

        // Optional: check for response status or success condition
        if (response=="Successfully created") {
            return {
                success: true,
                message: "Data submitted successfully!",
                data: response.data, // or just `response` if no `.data`
            };
        }

        return {
            success: false,
            message: "Unexpected response from server.",
            data: response,
        };

    } catch (error) {
        return {
            success: false,
            message: error?.response?.data?.message || "An error occurred",
            error,
        };
    }
};


export const updateSectionData = async (request, payload) => {
    try {
        const response = await request(
            "PUT",
            `/v1/city-profile/properties`,
            {
                data: payload.putPayload,
            },
            "survey_service"
        );

        // Optional: check for response status or success condition
        if (response== "Successfully updated") {
            return {
                success: true,
                message: "Updated Data successfully!",
                data: response.data, // or just `response` if no `.data`
            };
        }

        return {
            success: false,
            message: "Unexpected response from server.",
            data: response,
        };

    } catch (error) {
        return {
            success: false,
            message: error?.response?.data?.message || "An error occurred",
            error,
        };
    }
};
